export default class ParameterResponse {
  id: string;

  parameterId: string;

  index: number;

  name: string;

  value: string;

  label: string;

  description: string;

  defaultValue: string;

  type: string;

  enabled: boolean;

  constructor(obj: any = {}) {
    this.id = obj.id || '';
    this.parameterId = obj.parameterId || '';
    this.index = obj.index || 0;
    this.name = obj.name || '';
    this.value = obj.value || '';
    this.label = obj.label || '';
    this.description = obj.description || '';
    this.defaultValue = obj.defaultValue || '';
    this.type = obj.type || '';
    this.enabled = obj.enabled || '';
  }

  public static of(obj: any = {}): ParameterResponse {
    return new ParameterResponse(obj || {});
  }

  public static ofList(obj: any[] = []): ParameterResponse[] {
    return obj.map(this.of);
  }
}
